<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
	<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
		<h3 *ngIf="regularAttachments?.length > 0">{{workOrder?.id}} {{'attachmentsView.title' | translate}}:</h3>
		<div *ngFor="let attachment of regularAttachments; let i = index" fxFlex
			 fxLayoutAlign="space-between center" fxLayoutGap="15px">
			<mat-icon>attachment</mat-icon>
			<div fxFlex>
				<a (click)="openFile(attachment)" *ngIf="access > 0" [disabled]="isFileOpening">
					{{attachment.fileName}} - {{attachment.description}}
				</a>
				<small *ngIf="access === 0">{{attachment.fileName}} - {{attachment.description}}</small>
				<!-- What the photo depicts. Empty unless the catalogue resolved, so it renders nothing
				     for an undeclared file, a gated-off tenant or a viewer who cannot read it. -->
				<span *ngIf="attachment._evidenceScenarioLabel" class="attachment-evidence-scenario">
					{{attachment._evidenceScenarioLabel}}
				</span>
				<mat-progress-bar [mode]="'determinate'" [value]="attachment?.progress || 100"
								  class="progress-bar"></mat-progress-bar>
			</div>
			<div *ngIf="attachment?.id" fxLayout="row wrap">
				<app-download-file-combo-button *ngIf="access > 0"
												[fileType]="fileExtensionRegex.exec(attachment.fileName)[1]"
												[id]="attachment.id"></app-download-file-combo-button>
				<button *ngIf="user?.token"
						(click)="removeAttachment(attachment)" [color]="'warn'" mat-icon-button
						matTooltip="Delete" matTooltipPosition="left">
					<mat-icon>delete</mat-icon>
				</button>
			</div>
		</div>
	</div>
	<div *ngIf="podAttachments?.length > 0" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
		<h3>{{'trackOrderDetailsView.deliveryAttachmentsHeader' | translate}}:</h3>
		<div *ngFor="let attachment of podAttachments; let i = index" fxFlex
			 fxLayoutAlign="space-between center" fxLayoutGap="15px">
			<mat-icon>attachment</mat-icon>
			<div fxFlex>
				<a (click)="openFile(attachment)" *ngIf="access > 0">
					{{attachment.fileName}} - {{attachment.description}}
				</a>
				<small *ngIf="access === 0">
					{{attachment.fileName}} - {{attachment.description}}
				</small>
				<span *ngIf="attachment._evidenceScenarioLabel" class="attachment-evidence-scenario">
					{{attachment._evidenceScenarioLabel}}
				</span>
				<mat-progress-bar [mode]="'determinate'" [value]="attachment?.progress || 100"
								  class="progress-bar"></mat-progress-bar>
			</div>
			<div *ngIf="attachment?.id" fxLayout="row">
				<app-download-file-combo-button *ngIf="access > 0"
												[fileType]="fileExtensionRegex.exec(attachment.fileName)[1]"
												[id]="attachment.id"></app-download-file-combo-button>
			</div>
		</div>
	</div>
</div>
